/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
    FactorMethodToJSONTyped,
} from './FactorMethod';
import type { OIDCUXMode } from './OIDCUXMode';
import {
    OIDCUXModeFromJSON,
    OIDCUXModeFromJSONTyped,
    OIDCUXModeToJSON,
    OIDCUXModeToJSONTyped,
} from './OIDCUXMode';
import type { OAuthProvider } from './OAuthProvider';
import {
    OAuthProviderFromJSON,
    OAuthProviderFromJSONTyped,
    OAuthProviderToJSON,
    OAuthProviderToJSONTyped,
} from './OAuthProvider';
import type { OIDCGroupsOptions } from './OIDCGroupsOptions';
import {
    OIDCGroupsOptionsFromJSON,
    OIDCGroupsOptionsFromJSONTyped,
    OIDCGroupsOptionsToJSON,
    OIDCGroupsOptionsToJSONTyped,
} from './OIDCGroupsOptions';

/**
 * 
 * @export
 * @interface OIDCMethodOptions
 */
export interface OIDCMethodOptions {
    /**
     * 
     * @type {FactorMethod}
     * @memberof OIDCMethodOptions
     */
    method: FactorMethod;
    /**
     * 
     * @type {string}
     * @memberof OIDCMethodOptions
     */
    client_id: string;
    /**
     * 
     * @type {OAuthProvider}
     * @memberof OIDCMethodOptions
     */
    provider: OAuthProvider;
    /**
     * 
     * @type {OIDCUXMode}
     * @memberof OIDCMethodOptions
     * @deprecated
     */
    ux_mode?: OIDCUXMode;
    /**
     * URL to redirect to after login at the third-party IdP.
     * @type {string}
     * @memberof OIDCMethodOptions
     */
    redirect_target?: string;
    /**
     * 
     * @type {OIDCGroupsOptions}
     * @memberof OIDCMethodOptions
     */
    requires_groups?: OIDCGroupsOptions;
    /**
     * 
     * @type {string}
     * @memberof OIDCMethodOptions
     */
    pkce_code_challenge?: string;
    /**
     * 
     * @type {string}
     * @memberof OIDCMethodOptions
     */
    csrf_token?: string;
}



/**
 * Check if a given object implements the OIDCMethodOptions interface.
 */
export function instanceOfOIDCMethodOptions(value: object): value is OIDCMethodOptions {
    if (!('method' in value) || value['method'] === undefined) return false;
    if (!('client_id' in value) || value['client_id'] === undefined) return false;
    if (!('provider' in value) || value['provider'] === undefined) return false;
    return true;
}

export function OIDCMethodOptionsFromJSON(json: any): OIDCMethodOptions {
    return OIDCMethodOptionsFromJSONTyped(json, false);
}

export function OIDCMethodOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): OIDCMethodOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'method': FactorMethodFromJSON(json['method']),
        'client_id': json['client_id'],
        'provider': OAuthProviderFromJSON(json['provider']),
        'ux_mode': json['ux_mode'] == null ? undefined : OIDCUXModeFromJSON(json['ux_mode']),
        'redirect_target': json['redirect_target'] == null ? undefined : json['redirect_target'],
        'requires_groups': json['requires_groups'] == null ? undefined : OIDCGroupsOptionsFromJSON(json['requires_groups']),
        'pkce_code_challenge': json['pkce_code_challenge'] == null ? undefined : json['pkce_code_challenge'],
        'csrf_token': json['csrf_token'] == null ? undefined : json['csrf_token'],
    };
}

export function OIDCMethodOptionsToJSON(json: any): OIDCMethodOptions {
    return OIDCMethodOptionsToJSONTyped(json, false);
}

export function OIDCMethodOptionsToJSONTyped(value?: OIDCMethodOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'method': FactorMethodToJSON(value['method']),
        'client_id': value['client_id'],
        'provider': OAuthProviderToJSON(value['provider']),
        'ux_mode': OIDCUXModeToJSON(value['ux_mode']),
        'redirect_target': value['redirect_target'],
        'requires_groups': OIDCGroupsOptionsToJSON(value['requires_groups']),
        'pkce_code_challenge': value['pkce_code_challenge'],
        'csrf_token': value['csrf_token'],
    };
}

